<template lang="pug">
v-btn(text @click="goToHelp") Documentation
</template>
<script>
  export default {
    methods: {
      goToHelp() {
        const { href } = this.$router.resolve({ name: 'help' })
        window.open(href, '_blank')
      }
    }
  }
</script>